<template>
  <footer class="km-footer">
    <div class="footer-main">
      <div class="footer-container">
        <!-- 品牌区 -->
        <div class="footer-brand">
          <div class="brand-logo">
            <span class="logo-badge">柯</span>
            <span class="logo-name">柯美自动化</span>
          </div>
          <p class="brand-desc">专注电容器自动化设备研发与制造，为工业自动化提供专业的设备解决方案。</p>
          <div class="brand-tags">
            <span class="brand-tag">机械设计</span>
            <span class="brand-tag">电气控制</span>
            <span class="brand-tag">液压系统</span>
          </div>
        </div>

        <!-- 快捷导航 -->
        <div class="footer-nav">
          <h4 class="footer-title">快捷导航</h4>
          <ul class="footer-links">
            <li><a @click="$router.push('/')">首页</a></li>
            <li><a @click="$router.push('/prod-list')">产品中心</a></li>
            <li><a @click="$router.push('/about')">关于我们</a></li>
            <li><a @click="$router.push('/contact')">联系我们</a></li>
          </ul>
        </div>

        <!-- 联系信息 -->
        <div class="footer-contact">
          <h4 class="footer-title">联系方式</h4>
          <div class="contact-list">
            <div class="contact-row">
              <Icon type="ios-call" size="15" class="ci" />
              <span>13865300917</span>
            </div>
            <div class="contact-row">
              <Icon type="ios-call-outline" size="15" class="ci" />
              <span>0563-4301737</span>
            </div>
            <div class="contact-row">
              <Icon type="ios-mail" size="15" class="ci" />
              <span>ningguokemei@163.com</span>
            </div>
            <div class="contact-row">
              <Icon type="ios-navigate" size="15" class="ci" />
              <span>宁国市经济技术开发区众益广场8幢101号</span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 版权栏 -->
    <div class="footer-bottom">
      <div class="footer-container footer-bottom-inner">
        <p class="copyright">{{ copyRightDate }} © 宁国市柯美自动化设备制造有限公司 版权所有</p>
        <p class="icp">专注自动化设备制造</p>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'GlobalFooter',
  data() {
    return {
      copyRightDate: `2008-${new Date().getFullYear()}`,
    };
  },
};
</script>

<style scoped lang="less">
.km-footer {
  width: 100%;
  background: var(--primary-dark);
  margin-top: 0;
}

/* 主要区域 */
.footer-main {
  padding: 56px 0 40px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
}

.footer-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 24px;
}

.footer-main .footer-container {
  display: grid;
  grid-template-columns: 2fr 1fr 2fr;
  gap: 48px;
}

/* 品牌区 */
.footer-brand {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.brand-logo {
  display: flex;
  align-items: center;
  gap: 10px;
}

.logo-badge {
  width: 38px;
  height: 38px;
  background: linear-gradient(135deg, #ff8c00, #ffa733);
  border-radius: 8px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
  font-weight: 800;
  color: #ffffff;
  box-shadow: 0 2px 8px rgba(255, 140, 0, 0.4);
  flex-shrink: 0;
}

.logo-name {
  font-size: 18px;
  font-weight: 700;
  color: #ffffff;
}

.brand-desc {
  font-size: 13px;
  line-height: 1.7;
  color: rgba(255, 255, 255, 0.6);
  margin: 0;
}

.brand-tags {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
}

.brand-tag {
  padding: 3px 10px;
  background: rgba(255, 255, 255, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.15);
  border-radius: 20px;
  font-size: 11px;
  color: rgba(255, 255, 255, 0.7);
  font-weight: 500;
}

/* 导航区 */
.footer-nav {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.footer-title {
  font-size: 14px;
  font-weight: 700;
  color: #ff8c00;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  padding-bottom: 10px;
  border-bottom: 1px solid rgba(255, 140, 0, 0.3);
  margin: 0;
}

.footer-links {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 10px;

  li a {
    font-size: 14px;
    color: rgba(255, 255, 255, 0.65);
    cursor: pointer;
    transition: color 0.2s;
    display: inline-flex;
    align-items: center;
    gap: 6px;

    &::before {
      content: '›';
      color: #ff8c00;
      font-size: 16px;
      line-height: 1;
    }

    &:hover {
      color: #ffffff;
    }
  }
}

/* 联系区 */
.footer-contact {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.contact-list {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.contact-row {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  font-size: 13px;
  color: rgba(255, 255, 255, 0.65);
  line-height: 1.5;

  .ci {
    color: #ff8c00;
    flex-shrink: 0;
    margin-top: 1px;
  }
}

/* 版权栏 */
.footer-bottom {
  padding: 16px 0;
  background: rgba(0, 0, 0, 0.2);
}

.footer-bottom-inner {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
}

.copyright,
.icp {
  margin: 0;
  font-size: 12px;
  color: rgba(255, 255, 255, 0.45);
  line-height: 1.5;
}

/* 响应式 */
@media (max-width: 1024px) {
  .footer-main .footer-container {
    grid-template-columns: 1fr 1fr;
    gap: 32px;
  }

  .footer-brand {
    grid-column: 1 / -1;
    flex-direction: row;
    align-items: flex-start;
    gap: 24px;
  }

  .brand-desc {
    max-width: 400px;
  }
}

@media (max-width: 768px) {
  .footer-main {
    padding: 36px 0 28px;
  }

  .footer-main .footer-container {
    grid-template-columns: 1fr;
    gap: 28px;
    padding: 0 16px;
  }

  .footer-brand {
    flex-direction: column;
  }

  .footer-bottom-inner {
    flex-direction: column;
    align-items: flex-start;
    gap: 6px;
  }
}

@media (max-width: 480px) {
  .footer-container {
    padding: 0 12px;
  }

  .footer-main {
    padding: 28px 0 20px;
  }
}
</style>
